import { useAuth } from '@/store/auth';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';
import { Button } from '../button';
import { useSignIn } from '../portfolio/data';

export default function SplashScreen() {
  const sigin = useSignIn();
  const [loading] = useAuth(useShallow((state) => [state.loading]));
  const { t } = useTranslation();

  useEffect(() => {
    const id = setTimeout(() => {
      sigin();
    }, 500);

    return () => clearTimeout(id);
  }, [sigin]);

  return (
    <div className="h-screen splash overscroll-none flex flex-col-reverse py-8 px-4">
      <Button
        isLoading={loading}
        disabled={!!loading}
        onClick={sigin}
        data-action="sign-in"
        className="text-base text-black font-medium h-14 px-4 rounded-full bg-white w-full disabled:opacity-50 "
      >
        {t('Sign in')}
      </Button>
    </div>
  );
}
